import { Routes } from '@angular/router';
import { TwoColumnsRightComponent } from '@fry/upgrade/main.template.directive';

// Import components as they are migrated
import { GoalEditComponent, GoalsListComponent, GoalViewComponent, ManageCategoriesComponent, TargetsLinkComponent } from '@fry/upgrade/goals.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import { authGuard, forceOnlineGuard } from '@fry-it/risr-core';
import { unsavedGuard } from '@fry/upgrade/unsaved.guard';

export const goalsRoutes: Routes = [
  {
    path: 'goals',
    component: TwoColumnsRightComponent,
    data: {
      permission: 'goals.work.own'
    },
    canActivate: [setupGuard, authGuard, forceOnlineGuard],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
      },
      {
        path: 'list',
        component: GoalsListComponent,
        data: {
          angularJsTemplate: 'app/components/goals/list.html',
          angularJsController: 'GoalsController',
          angularJsControllerAs: 'goalsCtrl',
          state: 'epf.goals.index',
          permission: 'goals.work.own'
        },
        canActivate: [forceOnlineGuard, authGuard]
      },
      {
        path: 'list/:filterId',
        component: GoalsListComponent,
        data: {
          angularJsTemplate: 'app/components/goals/list.html',
          angularJsController: 'GoalsController',
          angularJsControllerAs: 'goalsCtrl',
          state: 'epf.goals.index',
          permission: 'goals.work.own'
        },
        canActivate: [forceOnlineGuard, authGuard]
      },
      {
        path: 'view/:goalId',
        component: GoalViewComponent,
        data: {
          angularJsTemplate: 'app/components/goals/goal.html',
          angularJsController: 'GoalController',
          angularJsControllerAs: 'goalCtrl',
          action: 'view',
          state: 'epf.goals.view',
          permission: 'goals.work.own'
        },
        canActivate: [forceOnlineGuard, authGuard]
      },
      {
        path: 'view/:goalId/:periodId',
        component: GoalViewComponent,
        data: {
          angularJsTemplate: 'app/components/goals/goal.html',
          angularJsController: 'GoalController',
          angularJsControllerAs: 'goalCtrl',
          action: 'view',
          state: 'epf.goals.view',
          permission: 'goals.work.own'
        },
        canActivate: [forceOnlineGuard, authGuard]
      },
      {
        path: 'work/:goalId',
        component: GoalViewComponent,
        data: {
          angularJsTemplate: 'app/components/goals/goal.html',
          angularJsController: 'GoalController',
          angularJsControllerAs: 'goalCtrl',
          action: 'work',
          state: 'epf.goals.work',
          permission: 'goals.work.own'
        },
        canActivate: [forceOnlineGuard, authGuard]
      },
      {
        path: 'add/:eventId/:sectionId/:fieldId',
        component: GoalEditComponent,
        data: {
          angularJsTemplate: 'app/components/goals/goals-definition.html',
          angularJsController: 'GoalsDefinitionController',
          angularJsControllerAs: 'GoalsDefinitionCtrl',
          action: 'add',
          state: 'epf.goals.add',
          permission: 'goals.work.own'
        },
        canActivate: [forceOnlineGuard, authGuard],
        canDeactivate: [unsavedGuard]
      },
      {
        path: 'edit-definition/:goalId',
        component: GoalEditComponent,
        data: {
          angularJsTemplate: 'app/components/goals/goals-definition.html',
          angularJsController: 'GoalsDefinitionController',
          angularJsControllerAs: 'GoalsDefinitionCtrl',
          action: 'edit',
          state: 'epf.goals.editDefinition'
        },
        canActivate: [forceOnlineGuard],
        canDeactivate: [unsavedGuard]
      },
      {
        path: 'targets/link/:goalId/:targetId/:periodId',
        component: TargetsLinkComponent,
        data: {
          angularJsTemplate: 'app/components/goals/targets.link.html',
          angularJsController: 'TargetsLinkController',
          angularJsControllerAs: 'targetsLinkController',
          state: 'epf.goals.link'
        },
        canActivate: [forceOnlineGuard]
      },
      {
        path: 'manage',
        component: ManageCategoriesComponent,
        data: {
          angularJsTemplate: 'app/components/goals/manage-categories.html',
          angularJsController: 'ManageCategoriesController',
          angularJsControllerAs: 'ctrl',
          state: 'epf.goals.manage-categories',
          permission: 'organisation.manage-categories'
        },
        canActivate: [forceOnlineGuard, authGuard],
        canDeactivate: [unsavedGuard]
      }
    ]
  }
];
